import { render, staticRenderFns } from "./bulma_field_IS.vue?vue&type=template&id=48638d8c&scoped=true&lang=html"
import script from "./bulma_field_IS.vue?vue&type=script&lang=js"
export * from "./bulma_field_IS.vue?vue&type=script&lang=js"
import style0 from "./bulma_field_IS.vue?vue&type=style&index=0&id=48638d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48638d8c",
  null
  
)

export default component.exports